import FlexPane from './_flex-pane.js'
import PayableInfo from './_payable-info.js'
import StakeInfo from './_stake-info.js'
import PrewagerStakeInfo from './_prewager-stake-info.js'
import CashStakeInfo from './_cash-stake-info.js'
import FreebetStakeInfo from './_freebet-stake-info.js'
import StakeTaxInfo from './_stake-tax-info.js'
import TotalPayoutInfo from './_total-payout-info.js'
import PayoutInfo from './_payout-info.js'

export default {
  name: 'PlaceBetCalculations',
  values: {
    calculationsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
          padding: '4px 0 8px',
        },
      },
    },
    totalPayable: {
      configSet: PayableInfo,
      configValues: {
        notAvailableValuel10nKey: '$BETSLIP.NOT_AVAILABLE',
      },
    },
    primaryTotalStake: {
      configSet: StakeInfo,
      configValues: {
        notAvailableValuel10nKey: '$BETSLIP.NOT_AVAILABLE',
      },
    },
    prewagerStake: {
      configSet: PrewagerStakeInfo,
      configValues: {},
    },
    cashStake: {
      configSet: CashStakeInfo,
      configValues: {},
    },
    freebetStake: {
      configSet: FreebetStakeInfo,
      configValues: {
        notAvailableValuel10nKey: '$BETSLIP.NOT_AVAILABLE',
      },
    },
    stakeTax: {
      configSet: StakeTaxInfo,
      configValues: {},
    },
    secondaryTotalStake: {
      configSet: StakeInfo,
      configValues: {
        notAvailableValuel10nKey: '$BETSLIP.NOT_AVAILABLE',
      },
    },
    totalPayoutInfo: {
      configSet: TotalPayoutInfo,
      configValues: {
        payout: {
          notAvailableValuel10nKey: '$BETSLIP.NOT_AVAILABLE',
        },
      },
    },
    oddsBoostInfo: {
      configSet: PayoutInfo,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
